export default "/images/img_about.png?2ef1c3e243eb902b81d00e74e1d712c2";